import { Component, OnInit, OnDestroy, Input, ViewChild } from '@angular/core';
import { Field } from '../../../_models/field';
import { UserProfile } from '../../../_models/user-profile';
import { PortalApiService } from '../../../_services/portal-api.service';
import { RouteParams } from '../../../_models/portal-routes';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FieldDataSheet } from '../../../_models/field';
import { DatePipe } from '@angular/common';
import { Subject } from 'rxjs';

@Component({
  selector: 'top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.css'],
  providers: [DatePipe]
})
export class TopBarComponent implements OnInit, OnDestroy {
  @Input() isLoadingField: boolean;
  @Input() userProfile: UserProfile;
  @Input() field: Field;
  @Input() errorField: string;
  ticketView: string = 'daily';
  isMonthlyView: boolean = true;
  receivedDataSheets: FieldDataSheet[] = [];
  startDate: string;
  endDate: string;
  entryDate: string;
  isLoadingDataSheets: boolean = false;
  fieldID: number;
  errorGetDataSheets: boolean = false;
  errorMessage: string;
  routeParams: RouteParams = new RouteParams;
  isBulkEdit: boolean = false;

  // Subjects
  private onDestroy$ = new Subject<void>();

  constructor(
    private apiService: PortalApiService,
    private route: ActivatedRoute,
    private router: Router,
    private datePipe: DatePipe,
  ) {
    this.setDateRange();
  }

  ngOnInit() {
    this.isBulkEdit = this.router.url.includes('bulkedit');

    this.route.params.subscribe(params => {
      this.fieldID = params['fieldID'];
      this.entryDate = params['entryDate'];
    });
    this.getFieldDataSheets();

    const queryParams = this.route.snapshot.queryParams;
    Object.keys(queryParams).forEach(param => {
      switch (param) {
        case 'view':
          this.ticketView = queryParams[param];
          break;
        default:
          break;
      }
    });
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  addFieldToFavorites() {
    this.apiService.addFieldToFavorites(this.field.fieldID)
      .subscribe(() => {
        this.field.isFavorite = true;
      });
  }

  removeFieldFromFavorites() {
    this.apiService.removeFieldFromFavorites(this.field.fieldID)
      .subscribe(() => {
        this.field.isFavorite = false;
      });
  }

  updateTicketView(viewName: string) {
    this.ticketView = viewName;
    this.updateQueryParams('view', viewName);
  }

  changeTicketView(viewName: string) {
    this.updateTicketView(viewName);
    this.getFieldDataSheets();
  }

  updateQueryParams(paramName: string, paramValue: any) {
    const updatedParam: Params = {};
    updatedParam[paramName] = paramValue;
    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: updatedParam,
        queryParamsHandling: 'merge'
      }
    );
  }

  setDateRange() {
    const startDate = new Date();
    const endDate = new Date();

    // Get data sheets in the last 30 days
    startDate.setMonth(endDate.getMonth() - 1);

    this.startDate = this.datePipe.transform(startDate, 'yyyy-MM-dd');
    this.endDate = this.datePipe.transform(endDate, 'yyyy-MM-dd');
  }

  getFieldDataSheets() {
    this.isLoadingDataSheets = true;

    this.apiService.getFieldDataSheets(this.fieldID, this.startDate, this.endDate).subscribe({
      next: (data: FieldDataSheet[]) => {
        //console.log(data);
        this.isLoadingDataSheets = false;
        this.receivedDataSheets = data;
      },
      error: err => {
        console.log(err)
        this.errorGetDataSheets = true;
        this.errorMessage = (err.error || 'An error occurred. Failed to retrieve field data sheets.');
        this.isLoadingDataSheets = false;
      }
    });
  }

  navigateToBulk() {
    this.router.navigate([`app/Portal/dataentry/field/${this.fieldID}`], {
      queryParams: { view: 'bulk' }
    });
  }
}
